<template>
  <div class="templates-language-control">
    <div class="templates-language-control__actions">
      <!-- link to translation -->
      <TemplatesTemplateStatus v-if="translation" :status="translation.status">
        <AppRouterLink
          exact
          title="Ir al detalle de esta plantilla"
          :to="{
            name: 'template-details',
            params: {
              temp_id: translation.id,
              temp_title: translationSlug,
            },
          }"
          class="templates-language-control__link"
        >
          Ver
        </AppRouterLink>
      </TemplatesTemplateStatus>

      <template v-else>
        <AppIcon v-if="!isEditor" icon="far fa-times" title="Sin traducción" />
        <!-- add translation -->
        <AppIcon
          v-else
          class="templates-language-control__add"
          icon="far fa-plus"
          title="Añadir traducción"
          @click="addTranslation"
        />
      </template>
    </div>
  </div>
</template>

<script>
// Utilities
import Authorization from 'Mixins/Authorization'
import { checkApiResponse, slugify } from 'Utils'
import { Notification } from 'Utils/Classes/Notification'
// Components
import AppIcon from 'Ui/AppIcon'
import AppRouterLink from 'Ui/AppRouterLink'
import TemplatesTemplateStatus from 'Modules/Templates/components/TemplatesTemplateStatus'

export default {
  name: 'TemplatesLanguageControl',

  components: {
    AppIcon,
    AppRouterLink,
    TemplatesTemplateStatus,
  },

  props: {
    template: {
      type: Object,
      required: true,
    },

    languageCode: {
      type: String,
      required: true,
    },
  },

  mixins: [Authorization],

  computed: {
    translation() {
      return this.template.translations[this.languageCode]
    },

    translationSlug() {
      return slugify(this.translation.title)
    },

    isPublished() {
      return this.translation.status === 'published'
    },

    noEditorTranslationIcon() {
      return this.translation ? 'far fa-check' : 'far fa-times'
    },
  },

  methods: {
    async addTranslation() {
      const data = {
        id: this.template.card_id,
        langCode: this.languageCode,
      }
      const translation = await this.$store.dispatch('templates/addTemplateTranslation', data)

      if (!checkApiResponse(translation)) {
        const notification = new Notification()
        notification.message = 'Hubo un error al crear la traducción, intentalo de nuevo'
        return translation
      }

      this.$router.push({
        name: 'template-edit',
        params: { temp_id: translation.data.card_id, temp_title: slugify(translation.data.title) },
      })
    },
  },
}
</script>

<style scoped>
.templates-language-control__link {
  color: var(--c-secondary);
  padding: 5px;
  margin: -5px;
  cursor: pointer;
  text-decoration: none;
}

.templates-language-control__link:hover {
  text-decoration: underline;
}

.templates-language-control__actions .app-icon {
  position: relative;
  font-size: 16px;
  color: var(--c-secondary);
  padding: 10px;
  margin: -10px;
  border-radius: 50px;
  transition: var(--transition--default);
}

.templates-language-control__actions .app-icon.templates-language-control__add:hover {
  cursor: pointer;
  transform: perspective(1px) scale3d(1.1, 1.1, 1.1);
}

/* .templates-language-control__actions .app-icon:after {
  display: inline-block;
  content: '→';
  position: absolute;
  top: -3px;
  left: 0;
  right: 0;
  margin: 0 auto;
  opacity: 0;
  transition: var(--transition--default);
} */

.templates-language-control__actions .app-icon:hover:after {
  opacity: 1;
}
</style>
